import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { STOCKITEMS_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  paytypes: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const usePayTypesListFetch = () => {
  const auth = useAuth();
  const [paytypestate, setState] = useState(initialState);
  const [paytypesearchValue, paytypesetSearchValue] = useState("");
  const [includeInactive, setIncludeInactive] = useState(false);
  const [paytypeloading, setLoading] = useState(false);
  const [paytypeerror, setError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true); // ✅ Prevent double fetching

  const accessToken = auth.auth.accessToken;

  const fetchPayTypesList = async (page, searchValue, reset = false) => {
    if (!hasMore && !reset) return; // Stop fetching if no more pages

    try {
      setLoading(true);
      setError(false);

      console.log(reset)

      const data = await API.fetchPayTypes(searchValue, page, includeInactive, "", accessToken);
        
      console.log(data)
      setState((prev) => ({
        ...prev,
        paytypes: reset ? data.paytypes : data.paytypes, // ✅ Only reset on filter/search change
        page: page + 1,
        total_pages: data.total_pages,
        total_results: data.total_results,
      }));

      setHasMore(data.paytypes.length > 0);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching stock items:", error);
      setError(true);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchPayTypesList(1, paytypesearchValue, true);
    }
  }, [firstLoad]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    fetchPayTypesList(1, paytypesearchValue, true); // ✅ Fetch when search/filter changes
  }, [paytypesearchValue, includeInactive]);

  return { paytypestate, paytypeloading, paytypeerror,paytypesearchValue, paytypesetSearchValue, setIncludeInactive, fetchPayTypesList };
};
